import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'APM_SERVICE_HISTORY',
    itemActionName: 'APM_SERVICE_HISTORY_ITEM',
});
